import { makeStyles } from "@material-ui/styles";

const drawerWidth = "20%";
export default makeStyles(theme => ({
  sidebar: {
    position: "fixed",
    top: 0,
    left: 0,
    height: "100vh",
    width: drawerWidth,
    borderRadius: "0px 36px 36px 0px",
    backgroundColor: theme.palette.primary.OrderMngmt_primary,
    overflow: "scroll",
    zIndex:"9999"
    },
    sidebarLogo: {
      alignItems: "center",
      background: "#FFFFFF",
      placeItems: "center",
      height: "auto",
     fontSize: "1.5rem",
    fontWeight: 700,
  },
  sidebarMenu :{
    position: "relative",
    height: "76vh"
},
sidebarMenuItem: {
  display: "flex",
  alignItems: "center",
  placeContent: "flex-start",
  fontSize: "18px",
  fontWeight: 500,
  color: "#fff",
  transition: "color 0.3s ease-in-out",
 
},
//this of active link
// sidebarMenuItem: {
//   color: "#0b5aa4",
// },
sidebarMenuItemIcon :{
  marginRight: "1rem",

},
sidebarMenuItemIcon :{
  fontSize: "1.9rem",
},
sidebarMenuItemText:
{
  paddingLeft:"3%",
  textDecoration:`none`
},
sidebarMenuIndicator: {
  height:"50px",
  position: "absolute",
  top: 0,
  left: "46%",
  width: "calc(100% - 50px)",
  borderRadius: "10px",
  border :"2px solid #fff",
  zIndex: -1,
  transform:'translateX(-50%)',
  transition: "0.3s ease-in-out",
},
sideMainText:{
color:theme.palette.primary.OrderMngmt_primary,
paddingTop:"2%",
marginBottom:"2%"
},
userSideImg:
{
  width: "100%",
  height:"20%" ,
  
   padding:"2%",
},
textSecondry:
{
  color:theme.palette.primary.OrderMngmt_light,
  margin:"1%",
},
textPrimary:{
  color:theme.palette.text.dark,
  },
  lowerMenu:{
  color:"#ffffff",
  borderTop:"1px solid white"
  },
  scroller:{
    position: "absolute",
    height: "100vh",
    top: "10px",
    left: "22.5%",
    width:"77%",
    paddingRight: "1%",
  },
  scrollerfull:{
    position: "absolute",
    height: "100vh",
    width: "97%",
    top: "10px",
    left: "1%",
    
  },
  subMenu:{
    paddingLeft:"13%",
    background:theme.palette.primary.OrderMngmt_light
  }
}
  ));
